import { get, post } from '@api/request';

export async function fetchCaptureJanuary1OwnersRuns(
  { appraisalNoticeService },
  authenticationToken,
) {
  const url = `${appraisalNoticeService}/prodigyappraisalnotices/capturejanuary1ownersruns`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchCaptureJanuary1OwnersRun(
  { appraisalNoticeService },
  authenticationToken,
  { captureJanuary1OwnerID },
) {
  const url = `${appraisalNoticeService}/prodigyappraisalnotices/capturejanuary1ownersruns/${captureJanuary1OwnerID}`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function addCaptureJanuary1OwnersRun(
  { appraisalNoticeService },
  authenticationToken,
  { payload },
) {
  const url = `${appraisalNoticeService}/prodigyappraisalnotices/capturejanuary1ownersruns`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
}
